import { ProductPricingRuleInterface } from '@vendasta/billing';

export interface ProductPricingRules {
  price: number;
  minUnits: number;
  maxUnits: number;
}

export function productPricingRulesFromApi(pprApi: ProductPricingRuleInterface[] | undefined): ProductPricingRules[] {
  return (pprApi || []).map((r) => {
    return {
      price: r.price || 0,
      minUnits: r.minUnits,
      maxUnits: r.maxUnits,
    } as ProductPricingRules;
  });
}
